import "../styles/layout-blog.css";

const BlogBody = (props) => {
  return (
    <div>
      <p className="p-body">{props?.message}</p>
    </div>
  );
};

export default BlogBody;
